import { Injectable } from '@angular/core';
import { CryptoEncryptionDecryptionService } from './crypto-encryption-decryption.service';

@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {
  constructor(
    private readonly cryptoSer: CryptoEncryptionDecryptionService
  ) {
  }

  setKeyData(key: string, data: any) {
    const randomKey = this.cryptoSer.makesoltKey();
    key = this.cryptoSer.encryptData(randomKey, key);
    const keyValue = this.cryptoSer.encryptData(randomKey, JSON.stringify(data));
    sessionStorage.setItem((key + ':' + randomKey), keyValue);
  }

  getKeyData(key: string): any {
    const matchedKey = this.findMatchingKey(key);
    if (matchedKey !== '') {
      return JSON.parse(matchedKey);
    }
    else {
      return undefined;
    }
  }

  getLocalStorageArrayKeyDetails(key: string, screenName: string): any {
    const matchedKey = this.findMatchingKey(key);
    if (matchedKey !== null) {
      const data = JSON.parse(matchedKey);
      return data.filter(x => x.ScreenName === screenName);
    }
  }

  removeAllKey() {
    const allKeys = this.getAllBrowserKey();
    if (allKeys.length > 0) {
      allKeys.forEach(singleKey => {
        sessionStorage.removeItem(singleKey);
      });
    }
  }

  removeKey(keyName: string) {
    const alreadyExistKey = this.isValidKey(keyName);
    if (alreadyExistKey !== '') {
      sessionStorage.removeItem(alreadyExistKey);
    }
  }

  removeStringKeyArray(key: string[]): boolean {
    key.forEach(singleKey => {
      sessionStorage.removeItem(singleKey);
    });
    return true;
  }

  private getAllBrowserKey(): any[] {
    // tslint:disable-next-line: only-arrow-functions
    return Object.keys(sessionStorage).reduce(function (obj, str) {
      if (str.indexOf(':') !== -1) {
        obj.push(str);
      }
      return obj;
    }, []);
  }

  private findMatchingKey(actualKey: string): any {
    const spliKey = this.isValidKey(actualKey);
    return spliKey !== '' ? this.cryptoSer.decryptData(spliKey.split(':')[1], sessionStorage.getItem(spliKey)) : '';
  }

  private isValidKey(key: string): string {
    const allKeys = this.getAllBrowserKey();

    let validKey = '';
    if (allKeys.length > 0) {
      allKeys.forEach(singleKey => {

        const splitStr = singleKey.split(':');
        const descKey = this.cryptoSer.decryptData(splitStr[1], splitStr[0]);
        if (!descKey.startsWith('error')) {
          if (key === descKey) {
            validKey = singleKey;
          }
        }

      });
    }
    return validKey;

  }
}
